<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
    :config="configs"
  >
    <template #ORDERDETAIL="{ params, visible }">
      <order
        v-if="visible"
        :orderDetails="params.dataDetails"
        :pageText="params.pageText"
        :footer-hide="false"
      ></order>
    </template>
    <template #PREVIEW="{ params, visible }">
      <img style="width: 100%" v-if="visible" :src="params.src" />
    </template>
    <template #showDetails>
      <div style="height: 650px; overflow: auto">
        <Tag
          type="border"
          v-for="item in list"
          :key="item"
          size="large"
          style="height: 32px; line-height: 32px"
        >
          {{ item }}
        </Tag>
      </div>
    </template>
    <template #ORDERTRACKER="{ params, visible }">
      <order-tracker :statusId="params.id" v-if="visible"></order-tracker>
    </template>
  </cTable>
</template>
<script>
import {
  getList,
  update,
  getChildPackage,
  saveValues,
  getValuesLogs,
  addFee,
  updateFee,
  delFee,
  getFee,
  saveFee,
  uploadFiles,
  boxList,
  allowToAgent,
} from "@/api/order/mps";
import axios from "@/libs/api.request";
import cTable from "@/base/common/index";
import { getOrderDetails } from "@/api/order/list";
import { getSelectType } from "@/api/public";
// import { getAllClient, getCompanies } from "@/api/user/client";
// import { getCurrency } from "@/api/finance/currency";
// import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
// import { getChargingType } from "@/api/double/list";
// import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
import copyClick from "@/utils/copyClick";
import order from "_c/order-details";
import orderTracker from "@/base/order_tracker";
import { getExpense } from "@/api/finance/expense";
export default {
  name: "mps",
  components: {
    cTable,
    order,
    orderTracker,
  },
  async created() {
    // let agentList = (await getAgent()).data.payload.rows
    const to_country = (await getCountry({ allow_arrive: 1 })).data.payload
      .rows;
    const from_country = (await getCountry({ allow_depart: 1 })).data.payload
      .rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "to_country") item.options = to_country;
      if (item.key === "from_country") item.options = from_country;
    });
    // this.modals.add.fields.forEach(t=>{
    // 	if(t.key === 'cod_agent')t.options = agentList
    // })
  },
  methods: {},
  data() {
    let that = this;
    return {
      list: [],
      status: [],
      statusObj: [],
      agentList: [],
      configs: {
        mergeRows: [
          "client_refer_code",
          "childNumber",
          "from_country",
          "to_country",
          "create_time",
          "claim_weight",
          "actual_weight",
          "service_name",
          "client_name",
          "values",
          "old_values",
          "deliver",
          "allow_to_agent",
          "checkbox",
          "total_fee",
          "btns",
        ],
        mergeRow: "client_refer_code",
      },
      client: [],
      companies: [],
      unit: [],
      bubble: [],
      currencyList: [],
      SubjectCost: [],
      methods: {
        getSelectType,
        getChildPackage,
        list(params) {
          return getList(params);
        },
        update,
        getOrderDetails,
        saveValues,
        getValuesLogs,
        addFee,
        updateFee,
        delFee,
        getFee,
        saveFee,
        uploadFiles,
        boxList,
        allowToAgent,
      },
      modals: {
        preview: {
          config: {
            title: that.$t("preview"),
          },
          contentSlot: "PREVIEW",
          footer: {
            show: false,
          },
        },
        AgentDelivery: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("allowToAgent", row, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ allow: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("AgentDeliveryAllowed"),
              key: "allow",
              component: "Select",
              placeholder: () =>
                this.$t("enter") + this.$t("AgentDeliveryAllowed"),
              clearable: false,
              default: "YES",
              options: [
                { label: this.$t("YES"), value: "YES" },
                { label: this.$t("NO"), value: "NO" },
              ],
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
          ],
        },
        orderDetail: {
          contentSlot: "ORDERDETAIL",
          config: {
            listFn: "list",
            modalBind: {
              width: "80%",
            },
          },
          footer: {
            show: false,
          },
        },
        orderTracker: {
          contentSlot: "ORDERTRACKER",
          config: {
            listFn: "list",
            modalBind: {
              width: "30%",
            },
          },
          footer: {
            show: false,
          },
        },
        details: {
          methods: {
            cancel: () => {
              this.list = [];
            },
          },
          contentSlot: "showDetails",
          config: {
            modalBind: {
              width: 50,
              draggable: true,
            },
            modalContentBind: {
              style: {
                height: "650px",
              },
            },
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("all") + this.$t("copy"),
                key: "copy",
                fnName: "copy",
                bind: {
                  type: "primary",
                  style: {
                    margin: "0 10px",
                  },
                },
              },
            ],
            methods: {
              copy: () => {
                let data = this.list.join("\r\n");
                copyClick.copyToClipboard(data, this);
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data.client_refer_code = data.client_refer_code.split("\n");
              this.$page
                .handleRequestMethods("update", data, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ status: 24 }, { airway_number: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 8,
              },
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
            {
              key: "status",
              name: () => this.$t("tip"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tip");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.status;
                },
              },
            },
          ],
        },
        values: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("saveValues", row, true, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              values: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ oldValues: 24 }, { values: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("old") + this.$t("DeclaredValue"),
              key: "oldValues",
              disabled: true,
              component: "Input",
              placeholder: () => this.$t("old") + this.$t("DeclaredValue"),
            },
            {
              name: this.$t("DeclaredValue"),
              key: "values",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("DeclaredValue"),
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
          ],
        },
        valuesLog: {
          config: {
            width: 1000,
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: this.$t("OriginalDeclaredValue"),
                key: "from_val",
              },
              {
                name: this.$t("DeclaredValue"),
                key: "to_val",
              },
              {
                name: this.$t("Remarks"),
                key: "remarks",
              },
              {
                name: this.$t("operate"),
                key: "operator_name",
              },
              {
                name: this.$t("operation time"),
                width: 160,
                key: "create_time",
              },
            ],
          },
        },
        freightAppend: {
          // contentSlot: "freight",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(
                  row.id ? "saveFee" : "addFee",
                  {
                    data: JSON.parse(JSON.stringify(this.list)),
                    ids: this.$page.selectAll.map((t) => t.client_refer_code),
                    client_refer_code: row.id,
                  },
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          btns: {
            list: [
              {
                name: () => this.$t("delete"),
                type: "del",
                fnName: "del",
                disabled() {
                  return !this.selectAll.length;
                },
                bind: {
                  type: "error",
                },
              },
            ],
            methods: {
              del() {
                this.$Modal.confirm({
                  title: this.$t("delete"),
                  width: 300,
                  content: this.$t("titleModal"),
                  onOk: async () => {
                    let xids = this.selectAll.map((t) => t._XID);
                    this.list = this.list.filter((t) => !xids.includes(t._XID));
                    if (!this.list.length) {
                      this.list.unshift({
                        expense_item_id: "",
                        expense_item_name: "",
                        amount: 0,
                      });
                    }
                    this.$forceUpdate();
                  },
                });
              },
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => true,
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning",
                    },
                    icon: "md-add",
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                  },
                ],
                methods: {
                  add() {
                    this.getModal("freightAppend").list.unshift({
                      expense_item_id: "",
                      expense_item_name: "",
                      amount: 0,
                    });
                  },
                  delete({ rowIndex, row }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: async () => {
                        this.getModal("freightAppend").list.splice(rowIndex, 1);
                        if (!this.getModal("freightAppend").list.length) {
                          this.getModal("freightAppend").list.unshift({
                            expense_item_id: "",
                            expense_item_name: "",
                            amount: 0,
                          });
                        }
                      },
                    });
                  },
                },
              },
              {
                type: "checkbox",
                width: 60,
                fixed: "left",
              },
              {
                name: () => this.$t("expense"),
                align: "left",
                key: "expense_item_id",
                placeholder() {
                  return this.$t("select") + this.$t("expense");
                },
                component: "Select",
                bind: {
                  style: "width:100%",
                  type: "number",
                },
                config: {
                  label({ row }) {
                    return row.name + (row.pin ? "(" + row.pin + ")" : "");
                  },
                  value: "id",
                },
                methods: {
                  async list({ field }) {
                    field.options = (await getExpense()).data.payload.rows;
                    this.$forceUpdate();
                  },
                },
              },
              {
                name: () => this.$t("reChAmount"),
                align: "left",
                key: "amount",
                component: "InputNumber",
                bind: {
                  min: 0,
                  style: "width:100%",
                },
              },
              {
                name: () => this.$t("Remarks"),
                key: "remarks",
                component: "Input",
              },
            ],
          },
        },
        upload: {
          footer: {
            ok: {
              name: () => this.$t("updateFile"),
            },
            cancel: {},
          },
          methods: {
            ok({ list }) {
              console.log(list);
              this.$page.getModal("upload").disabledConfirm = true;
              let data = new FormData();
              for (var i = 0; i < list.length; i++) {
                if (list[i] instanceof File) data.append("files[]", list[i]); // 文件对象
              }
              this.$page
                .handleRequestMethods("uploadFiles", data, true, true)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getModal("upload").disabledConfirm = false;
                  this.$page.getModal("upload").list = res.payload;
                  this.$page.getList();
                })
                .catch((err) => {
                  this.$page.getModal("upload").disabledConfirm = false;
                });
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              maskClosable: false,
            },
            modalContentBind: {
              style: {
                height: "500px",
              },
            },
            // formBind: {
            //   labelWidth: 120
            // },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx,.xls",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  this.$refs["table"].getModal("upload").list.push(file);
                  this.$refs["table"].getModal(
                    "upload"
                  ).disabledConfirm = false;
                  return false;
                },
              },
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                name: () => this.$t("fileName"),
                key: "name",

                minWidth: 140,
              },
              {
                name: () => this.$t("updateFile") + this.$t("exlType"),

                key: "status",
                minWidth: 80,
                render(h, { row }) {
                  console.log("row", row);

                  return h(
                    "span",
                    {
                      style: {
                        color:
                          row.status != undefined
                            ? row.status
                              ? "green"
                              : "red"
                            : "blue",
                      },
                    },
                    row.status != undefined
                      ? row.status
                        ? this.$t("updateFile") + this.$t("success")
                        : this.$t("updateFile") + this.$t("error")
                      : this.$t("preparing")
                  );
                },
              },
              {
                name: () => this.$t("tip1"),

                key: "msg",
                minWidth: 110,
              },
              {
                name: () => this.$t("operate"),

                key: "user",
                minWidth: 110,
              },
              {
                name: () => this.$t("updateFile") + this.$t("date"),

                key: "date",
                minWidth: 170,
              },
              {
                name: () => this.$t("operation"),

                width: 60,
                render(h, { row, index }) {
                  return h("Icon", {
                    props: { type: row && !row.status ? "md-trash" : "" },
                    on: {
                      click: () => {
                        if (row && !row.status) this.list.splice(index, 1);
                      },
                    },
                  });
                },
              },
            ],
          },
        },
        showPack: {
          // contentSlot: "PACK",
          type: "add",
          footer: {
            show: () => false,
            cancel: {},
          },
          methods: {
            ok({ row }) {},
            cancel() {},
          },
          config: {
            modalBind: {
              width: 1000,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
            },
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_bill_number",

                minWidth: 100,
              },
              {
                name: () => this.$t("download") + this.$t("address"),

                key: "down_url",
                minWidth: 60,
                render(h, { row }) {
                  return h(
                    "Button",
                    {
                      props: {
                        type: "warning",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.$page.handleRequestMethods(
                            "readPackBox",
                            row.client_refer_code
                          );
                          window.open(this.$globalUrl + row.src, "_blank");
                        },
                      },
                    },
                    this.$t("download")
                  );
                },
              },
              //       {
              //         name: () => this.$t("preview") + this.$t("address"),

              //         key: "preview_url",
              //         minWidth: 60,
              //         render(h, { row }) {
              //           return h(
              //             "Button",
              //             {
              //               props: {
              //                 type: "warning",
              //                 size: "small",
              //               },
              //               on: {
              //                 click: () => {
              //                   this.$page.handleRequestMethods(
              //                     "readPackBox",
              //                     row.id
              //                   );
              //                   window.open(
              //                     "https://view.officeapps.live.com/op/view.aspx?src=" +
              //                       this.$globalUrl +
              //                       row.src,
              //                     "_blank"
              //                   );
              //                 },
              //               },
              //             },
              //             this.$t("preview")
              //           );
              //         },
              //       },
              {
                name: () => this.$t("operate"),

                key: "operator_name",
                minWidth: 110,
              },
              {
                name: () => this.$t("createTime"),

                key: "create_time",
                minWidth: 110,
              },
              {
                name: () => this.$t("auditOrder") + this.$t("exlType"),

                key: "verify",
                minWidth: 110,
                methods: {
                  render: ({ row }) => {
                    return row.verify === 1
                      ? this.$t("pass")
                      : this.$t("noPass");
                  },
                },
                render(h, params) {
                  return h(
                    "div",
                    {
                      style: {
                        color: params.row.verify === 1 ? "#19b16b" : "#f5222d",
                      },
                    },
                    params.row.verify === 1
                      ? this.$t("pass")
                      : this.$t("noPass")
                  );
                },
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            config: { label: "account", value: "id" },
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("allow_depart");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("order_number");
            },
            bind: {
              type: "textarea",
              rows: 2,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            // {
            //   name: () => this.$t("Update Status"),
            //   fnName: "updateStatus",
            //   type: "updateStatus",
            //   bind: {
            //     type: "primary",
            //   },
            // },
            {
              name: () => this.$t("setting") + this.$t("freight_append"),
              type: "append",
              fnName: "append",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.selectAll.reduce((a, b) => {
                    if (!a) a = b.to_country;
                    if (a !== b.to_country) return -1;
                    return a;
                  }, "") === -1
                );
              },
            },
            {
              name: () => this.$t("batch update PLInvoice"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "primary",
                icon: "ios-cloud-upload",
              },
            },
            {
              name: this.$t("download_tem"),
              type: "down",
              url: "/excel/tmp/MUL_INV_PL_TPL.xlsx",
              fnName: "down",
              bind: {
                type: "primary",
                size: "small",
              },
            },
          ],
          methods: {
            async export({ searchForm }) {
              let data = [];
              if (this.selectAll.length) {
                data = this.selectAll;
              } else {
                let res = await this.handleRequestMethods(
                  "list",
                  { ...searchForm, page: 1, export: 1, pageSize: 10000 },
                  false,
                  true
                );
                data = res.payload.rows;
              }
              this.exportExc({ data });
            },
            down({ field }) {
              window.open(this.$globalUrl + field.url);
            },
            upload() {
              this.getModal("upload").open(null, () => {
                this.getModal("upload").setTitle(this.$t("updateFile"));
                this.getModal("upload").disabledConfirm = true;
              });
            },
            append() {
              this.getModal("freightAppend").open({}, function () {
                this.setTitle(this.$t("setting") + this.$t("freight_append"));
                this.list.push({
                  expense_item_id: "",
                  expense_item_name: "",
                  amount: 0,
                });
              });
            },
            updateStatus() {
              this.getModal("add").open(
                {
                  airway_number: this.selectAll
                    .map((t) => t.client_refer_code)
                    .join("\n"),
                },
                function () {
                  this.setTitle(this.$t("Update Status"));
                }
              );
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
          key: "checkbox",
        },
        {
          name: () => that.$t("master bill number"),
          key: "client_refer_code",
          align: "center",
          fixed: "left",
          copy: true,
          width: 160,
          header: {
            copy: true, //头部复制
          },
          showOverflow: false,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              this.$page
                .handleRequestMethods("getOrderDetails", row.client_refer_code)
                .then((res) => {
                  this.$page.getModal("orderDetail").open(
                    {
                      dataDetails: res.payload,
                      pageText: 9,
                    },
                    function () {
                      this.setTitle(row.client_refer_code);
                    }
                  );
                });
            },
          },
        },
        {
          name: this.$t("childOrderPcs"),
          key: "childNumber",
          minWidth: 120,
        },
        {
          name: this.$t("allow_depart"),
          key: "from_country",
          minWidth: 120,
        },
        {
          name: this.$t("claim_weight"),
          key: "claim_weight",
          minWidth: 120,
        },
        {
          name: this.$t("actual_weight"),
          key: "actual_weight",
          minWidth: 120,
        },
        {
          name: this.$t("createTime"),
          key: "create_time",
          minWidth: 150,
        },

        {
          name: this.$t("serviceAccount"),
          key: "service_name",
          minWidth: 120,
        },
        {
          name: this.$t("clientName"),
          key: "client_name",
          minWidth: 120,
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          align: "center",
          minWidth: 100,
          component: "Button",
          bind: {
            size: "small",
            type: "primary",
          },
          methods: {
            click({ row }) {
              this.$page
                .handleRequestMethods(
                  "getValuesLogs",
                  row.client_refer_code,
                  false,
                  true
                )
                .then((res) => {
                  this.$page.getModal("valuesLog").open({}, function () {
                    this.setTitle(this.$t("DeclaredValue") + this.$t("record"));
                    this.list = res.payload;
                  });
                });
            },
          },
        },
        {
          name: this.$t("OriginalDeclaredValue") + "(USD)",
          key: "old_values",
          minWidth: 120,
        },
        {
          name: () => this.$tz("税费"),
          key: "total_fee",
          minWidth: 110,
        },
        {
          name: this.$t("localFaction"),
          key: "deliver",
          minWidth: 120,
        },
        {
          name: this.$t("AgentDeliveryAllowed"),
          key: "allow_to_agent",
          minWidth: 150,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              console.log("chufa", this, arguments);
              this.$page.getModal("AgentDelivery").open(row, function () {
                this.setTitle(
                  this.$t("AgentDeliveryAllowed") + `(${row.client_refer_code})`
                );
              });
            },
            render({ value }) {
              return this.$t(value);
            },
          },
        },
        {
          name: this.$t("child  bill number"),
          key: "airway_number",
          minWidth: 150,
        },
        {
          name: () => that.$t("length") + "(CM)",
          key: "length",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => that.$t("width") + "(CM)",
          key: "width",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => that.$t("height") + "(CM)",
          key: "height",
          align: "center",
          minWidth: 80,
        },
        {
          name: this.$t("tracker_code"),
          key: "status",
          minWidth: 100,
          render(h, p) {
            return h(
              p.row.status === "POD" && p.row.deliver.includes("VNLIN")
                ? "Button"
                : "span",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                },
                on: {
                  click() {
                    p.row.status === "POD" &&
                      p.row.deliver.includes("VNLIN") &&
                      (that.$refs["table"].openLoading(),
                      axios
                        .request({
                          url: "/api/signPic/" + p.row.airway_number,
                          method: "get",
                          responseType: "blob",
                        })
                        .then((res) => {
                          that.$refs["table"].closeLoading();
                          that.$refs["table"]
                            .getModal("preview")
                            .open({ src: URL.createObjectURL(res.data) });
                        }));
                  },
                },
              },
              p.row.status
            );
          },
        },
        {
          name: this.$t("track_title"),
          key: "status_remarks",
          minWidth: 120,
        },
        {
          name: this.$t("tracker_time"),
          key: "status_time",
          minWidth: 150,
        },
        {
          name: this.$t("trajectory"),
          key: "trajectory",
          width: 100,
          fixed: "right",
          component: "Button",
          bind: {
            size: "small",
            type: "primary",
          },
          methods: {
            render() {
              return this.$t("showDetail");
            },
            click({ row }) {
              this.$page.getModal("orderTracker").open(
                {
                  id: row.airway_number,
                },
                function () {
                  this.setTitle(row.airway_number);
                }
              );
            },
          },
        },
        {
          type: "btns",
          width: 150,
          key: "btns",
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("DeclaredValue"),
              type: "values",
              fnName: "values",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$t("setting") + this.$t("freight_append"),
              type: "append",
              fnName: "append",
              bind: {
                icon: "md-add",
                type: "warning",
              },
            },
            {
              name: () => this.$t("boxOrder"),
              type: "packList",
              fnName: "packList",
              bind: {
                type: ({ row }) => {
                  return row.hasBox ? "success" : "default";
                },
              },
            },
          ],
          methods: {
            packList({ row }) {
              this.handleRequestMethods("boxList", row.client_refer_code).then(
                (res) => {
                  this.getModal("showPack").open({}, function () {
                    this.list = res.payload.rows;
                    this.setTitle(
                      this.$t("boxOrder") + `(${row.client_refer_code})`
                    );
                  });
                }
              );
            },
            append({ row }) {
              this.handleRequestMethods(
                "getFee",
                row.client_refer_code,
                false,
                true
              ).then((res) => {
                this.getModal("freightAppend").open(
                  { id: row.client_refer_code },
                  function () {
                    this.setTitle(
                      this.$t("setting") +
                        this.$t("freight_append") +
                        `(${row.client_refer_code})`
                    );
                    this.list = res.payload;
                    !this.list.length &&
                      this.list.push({
                        expense_item_id: "",
                        expense_item_name: "",
                        amount: 0,
                      });
                  }
                );
              });
            },
            values({ row }) {
              this.getModal("values").open(
                { oldValues: row.values, id: row.client_refer_code },
                function () {
                  this.setTitle(
                    this.$t("DeclaredValue") + `(${row.client_refer_code})`
                  );
                }
              );
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
